(function($){
	
  var slider_option01 = {};
  
  slider_option01 = {
    loop: true,
    centeredSlides: false,
    slidesPerView: 1.3,   
    spaceBetween: 10, 
    speed:500,
    // autoplay: {
    //   delay: 5000,
    // },
    breakpoints: {
      767: {
        centeredSlides: true,
        slidesPerView: 2,  
        spaceBetween: 30,  
      }
    },
    pagination: {
      el: '.mv-pagenation',
      clickable: true,
    }
  }
  
  // MVスライダー
  new Swiper('.mv-swiper', slider_option01);
  
  ///////////// 重要なお知らせclose /////////////
  $('#important-close').click(function(){
    $('#important').addClass('none');
  });
  
  /////////////　重要なお知らせローディング /////////////
  var important_Storage = function () {
    if (sessionStorage.getItem('important_access')) {
      //2回目以降アクセス時の処理
      $("#important").hide();
      $('#important').addClass("none");	
      
    } else {
      //初回アクセス時の処理
      $('#important').removeClass("none");
      $('#important-close').click(function(){
        sessionStorage.setItem('important_access', 0);
      });
    }
  }
  important_Storage();
  
  })( jQuery );